import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import styled from 'styled-components'
import Logo from '../Logo'
import Navbar from './Navbar'
import MobileNav from './MobileNav'
import IconNav from './IconNav'
import { device } from '../../../utils/helpers'
import { withRouter } from 'react-router'

const Wrapper = styled.header`
  width: 100%;
  display: flex;
  height: 80px;
  background: ${props => props.theme.color.bgDark};
  align-items: center;
  justify-content: space-between;
  z-index: 10000;
  position: fixed;

  @media ${device.tablet} {
    ${''}
    position: fixed;
    height: ${props => props.isSmaller ? '90px' : '120px'};
    height: ${props => props.isStrutture && '100px'};
  }

  @media ${device.desktop} {
    height: ${props => props.isSmaller ? '100px' : '120px'};
    height: ${props => props.isStrutture && '100px'};
  }
`

const Icon = styled.i`
  color: #fff;
  padding-right: 1.5rem;

  @media ${device.tablet} {
    display: none;
  }
`

const LogoWrapper = styled.div`
  flex-basis: 18%;
  padding-left: 1.5rem;
`

class Header extends Component {
  state = {
    menuOpen: false
  }

  toggleMenu () {
    this.setState({ menuOpen: !this.state.menuOpen })
  }

  render () {
    const { menuItems } = this.props
    const { menuOpen } = this.state
    const { pathname } = this.props.location
    // Routes where default height should be 100px
    const smallerNavRoutes = ['strutture', 'noleggia']
    // const smallerNavRoutes = []
    return (
      <React.Fragment>
        <Wrapper isStrutture={pathname.includes('strutture')} isSmaller={smallerNavRoutes.some(route => pathname.includes(route))}>
          <LogoWrapper>
            <Logo />
          </LogoWrapper>
          <Icon onClick={this.toggleMenu.bind(this)} className='fas fa-bars fa-2x' />
          <Navbar items={menuItems} />
          <IconNav />
        </Wrapper>
        {menuOpen && <MobileNav items={menuItems} />}
      </React.Fragment>
    )
  }
}

export default withRouter(Header)



// WEBPACK FOOTER //
// ./src/components/UI/Header/index.js